




























































































































import { Component, Ref } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { AuthAction } from '@/store/AuthModule';
import AButton from '@/components/common/AButton.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { Util } from '@/utils/Util';
import { InfoIcon } from 'vue-feather-icons';
import { AdmiralError, ILogin } from 'admiral-core';
import FormError from '@/components/common/forms/FormError.vue';
import { FormMixin } from '@/mixins/FormMixin';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInputPassword from '@/components/common/forms/FormInputPassword.vue';
import LoginForm from '@/views/pages/auth/LoginForm.vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import { HealthApi } from '@/services/HealthApi';
import MagicLinkModal from '@/modals/MagicLinkModal.vue';
import { BModal } from 'bootstrap-vue';
import { AuthApi } from '@/services/AuthApi';
import LoginLoading from '@/views/pages/auth/LoginLoading.vue';
import MagicLinkRedirectModal from '@/modals/MagicLinkRedirectModal.vue';

export type LoginModel = Pick<ILogin, 'email' | 'password'>;

export enum LoginState {
  INITIAL,
  LOADING,
  LOGGING_IN,
  SUCCESS,
  LOGGED_IN,
  REDIRECT,
  FAIL,
}

@Component({
  name: 'login',
  components: {
    MagicLinkRedirectModal,
    LoginLoading,
    MagicLinkModal,
    FormSubmit,
    LoginForm,
    FormInputPassword,
    FormRow,
    FormInput,
    FormError,
    AButton,
    InfoIcon,
  },
})
export default class Login extends mixins(FormMixin, BaseMixin) {
  model = this.defaultModel();

  isLoggingIn = false;
  isPasswordVisible = false;

  loadingScreen = false;
  loadingScreenDone = false;

  magicLinkHint = false;

  loginState: LoginState = LoginState.INITIAL;

  magicLinkCode = '';

  @Ref('magic-link-modal') magicLinkModal!: MagicLinkModal;
  @Ref('magic-link-redirect-modal') magicLinkRedirectModal!: MagicLinkRedirectModal;

  defaultModel(): LoginModel {
    return {
      email: '',
      password: '',
    };
  }

  async mounted() {
    try {
      console.log('user agency', this.user.agency);
      const response = await HealthApi.getApiVersion();
      const version = response.data.version;
      if (version !== process.env.VUE_APP_VERSION) {
        location.reload();
      }

      if (this.$route.query['magic-link-code']) {
        this.magicLinkCode = this.$route.query['magic-link-code'] as string;
        (this.magicLinkRedirectModal.$refs['magic-link-redirect-modal'] as BModal).show();
        const channel = new BroadcastChannel('app-data');
        channel.postMessage(this.magicLinkCode);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async resendMagicLink(email: string) {
    (this.magicLinkRedirectModal.$refs['magic-link-redirect-modal'] as BModal).hide();
    this.model.email = email;
    await this.handleSubmitMagicLink(email);
  }

  async handleLogin() {
    this.resetErrors();
    this.magicLinkHint = false;
    try {
      this.$Progress.start();
      this.isLoggingIn = true;

      await this.$store.dispatch(`AuthModule/${AuthAction.Login}`, {
        email: this.model.email?.trim(),
        password: this.model.password?.trim(),
      });

      this.loginState = LoginState.LOADING;
      await Util.wait(100);
      this.loginState = LoginState.LOGGING_IN;
      await Util.wait(1000);

      this.loadingScreen = true;
      this.isLoggingIn = false;

      this.loginState = LoginState.SUCCESS;
      this.$Progress.finish();

      await Util.wait(1000);

      this.loginState = LoginState.LOGGED_IN;

      await this.fetchDataAfterLogin();

      this.loadingScreen = false;
      this.loadingScreenDone = true;
      this.isLoggingIn = false;
      this.isDone = true;
      await Util.wait(1000);
      // this.loginState = LoginState.REDIRECT;

      await this.$router.push({
        name: 'start',
      });
      this.loginState = LoginState.INITIAL;

      this.loadingScreenDone = false;
    } catch (e) {
      this.loginState = LoginState.INITIAL;

      const apiErrors = this.exceptionErrors(e);
      this.addError(
        apiErrors['emailisNotEmpty'] || apiErrors['emailisEmail'],
        'email',
        'Bitte eine gültige E-Mail Adresse angeben.',
      );
      this.addError(
        apiErrors[AdmiralError.CancelledPlan],
        'general',
        'Zugang nicht möglich. Bitte setze Dich mit unserem Team (team@admiral-dashboard.de) in Verbindung.',
      );
      this.addError(apiErrors['passwordisNotEmpty'], 'password', 'Bitte ein Passwort angeben.');
      this.addError(
        apiErrors[AdmiralError.LoginIncorrectPassword],
        'general',
        'Die E-Mail oder das Passwort sind nicht korrekt.',
      );

      this.addError(
        apiErrors[AdmiralError.LoginMaxAttempts] || apiErrors[AdmiralError.SuspendedAccount],
        'general',
        'Das Passwort wurde zu oft falsch eingegeben. Der Account wurde gesperrt. Bitte setze das Passwort unter "Passwort vergessen" zurück.',
      );
      this.addError(
        apiErrors[AdmiralError.DeactivatedAccount],
        'general',
        'Der Account wurde gesperrt. Bitte setze dich mit dem Administrator in Verbindung.',
      );

      if (apiErrors['passwordisNotEmpty'] || apiErrors[AdmiralError.LoginIncorrectPassword]) {
        this.magicLinkHint = true;
      }

      this.$Progress.fail();
    } finally {
      this.isLoggingIn = false;
    }
  }

  async successMagicLinkLogin() {
    this.loginState = LoginState.LOGGED_IN;
    await Util.wait(1000);

    await this.$router.push({
      name: 'policies.all',
    });
  }

  async handleSubmitMagicLink(email: string) {
    try {
      this.magicLinkHint = false;

      (this.magicLinkModal.$refs['magic-link-modal'] as BModal).show();

      await AuthApi.sendMagicLink({
        email,
      });
      const channel = new BroadcastChannel('app-data');
      channel.addEventListener('message', (event) => {
        (this.magicLinkModal.$refs['magic-link-modal'] as BModal).hide();
        this.magicLinkCode = event.data;
        (this.magicLinkRedirectModal.$refs['magic-link-redirect-modal'] as BModal).show();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);
      this.addError(
        apiErrors['emailisNotEmpty'] || apiErrors['emailisEmail'],
        'email',
        'Bitte eine gültige E-Mail Adresse angeben.',
      );
    }
  }
  get stateLoading() {
    return this.loginState === LoginState.LOADING;
  }

  get stateLoggingIn() {
    return this.loginState === LoginState.LOGGING_IN;
  }

  get stateLoggedIn() {
    return this.loginState === LoginState.LOGGED_IN;
  }

  get stateLoginProcess() {
    return (
      this.loginState === LoginState.LOADING ||
      this.loginState === LoginState.LOGGING_IN ||
      this.loginState === LoginState.SUCCESS ||
      this.loginState === LoginState.LOGGED_IN
    );
  }
}
